
<template>
  <div class="paymeyhods_content">
    <van-radio-group v-model="checked" @change="checkPayMethod">
      <div
        class="paymeyhods_items"
        v-for="(item, index) in PayMethods"
        :key="index"
      >
        <van-radio :name="item.Id">{{ item.Name }}</van-radio>
      </div>
    </van-radio-group>
  </div>
</template>
<script>
import axios from "../commons/AxiosMethod.js"
import { showToast } from "vant"
export default {
  name: "header",
  data () {
    return {
      PayMethods: [], // 超出配送距离地址集合
      checked: ""
    }
  },
  props: {
    AttributeGroup: {}
  },
  components: {},
  mounted () {
    this.GetPayMethods()
  },
  methods: {
    // 加载支付方式
    GetPayMethods () {
      axios.apiMethod(
        "/Orders/Order/GetPayMethods",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.PayMethods = result.Data
            this.checked = this.PayMethods[0].Id
          } else {
            showToast(result.Msg)
          }
        },
        (e) => {}
      )
    },
    checkPayMethod (id) {
      this.$emit("update:modelValue", id)
    }
  }
}
</script>
<style  lang="scss"  scoped>
.paymeyhods_content {
  z-index: 100023144432;
  padding: 20px;
  .paymeyhods_items {
    padding: 5px;
    width: calc(100% - 40px);
  }
}
</style>
